import React from "react";
import { 
  FaPlane, 
  FaHotel, 
  FaGift, 
  FaTicketAlt, 
  FaCreditCard,
  FaUmbrellaBeach,
  FaShieldAlt,
  FaChartLine,
  FaGlobeAmericas
} from 'react-icons/fa';

export function ProductCard({  category, revenue, transactions, sharePercentage }) {
  // Function to get the icon component based on category
  const getIconComponent = (category) => {
    switch(category.toLowerCase()) {
      case 'flights':
        return FaPlane;
      case 'travx':
        return FaGlobeAmericas;
      case 'hotels':
        return FaHotel;
      case 'packages':
        return FaGift;
      case 'post-ticketing':
        return FaTicketAlt;
      case 'subscriptions':
        return FaCreditCard;
      case 'tours':
        return FaUmbrellaBeach;
      case 'insurance':
        return FaShieldAlt;
      default:
        return FaChartLine;
    }
  };

  // Get the icon component for the category
  const CategoryIcon = getIconComponent(category);

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all duration-200 cursor-pointer">
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
            <CategoryIcon size={20} className="text-blue-600" />
          </div>
          <div className="text-sm font-medium text-gray-900 truncate">{category}</div>
        </div>

        {/* Revenue */}
        <div className="text-2xl font-semibold text-gray-900">{revenue}</div>

        {/* Transactions and Contribution Row */}
        <div className="flex items-center justify-between text-sm text-gray-500">
          <span>{transactions} txns</span>
          <span className="font-medium text-gray-900">{sharePercentage}{"%"}</span>
        </div>

        {/* Progress bar */}
        <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-blue-600 rounded-full transition-all duration-300"
            style={{ width: sharePercentage }}
          />
        </div>
      </div>
    </div>
  );
}